module.exports = __webpack_public_path__ + "img/face_shape_female_average.6cf52920.png";